import { useEffect, useState } from "react";

export const useWhQuestions = (generatedQuestionsFromSubmitContent) => {
  const [whQuestions, setWhQuestions] = useState([]);
  const [totalWhQuestions, setTotalWhQuestions] = useState(0);

  const shortQuestionsNotWH =
    generatedQuestionsFromSubmitContent?.response?.short_questions?.questions ||
    generatedQuestionsFromSubmitContent?.questionset?.short_questions?.questions ||
    generatedQuestionsFromSubmitContent?.short_questions?.questions ||
    [];

  useEffect(() => {
    setTotalWhQuestions(whQuestions.length);
  }, [whQuestions]);


  const handleShortWhQuestionChange = (index, newValue) => {
    const updatedQuestions = [...whQuestions];
    updatedQuestions[index].Question = newValue;
    setWhQuestions(updatedQuestions);
  };

  const handleShortWhAnswerChange = (index, newValue) => {
    const updatedQuestions = [...whQuestions];
    updatedQuestions[index].Answer = newValue;
    setWhQuestions(updatedQuestions);
  };

  const handleShortWhQuestionsEdit = (index) => {
    const updatedQuestions = [...whQuestions];
    updatedQuestions[index].editing = !updatedQuestions[index].editing;

    if (updatedQuestions[index].editing) {
      // After setting editing to true, focus on the contentEditable div for the question
      setTimeout(() => {
        const contentEditableElement = document.getElementById(
          `question-${index}`
        ); // Add an ID to your contentEditable element
        if (contentEditableElement) {
          contentEditableElement.focus();
        }
      }, 0);
    }

    setWhQuestions(updatedQuestions);
  };

  const handleShortWhAnswersEdit = (index) => {
    const updatedQuestions = [...whQuestions];
    if (updatedQuestions[index]) {
      updatedQuestions[index].editingAnswer =
        !updatedQuestions[index].editingAnswer;
      setWhQuestions(updatedQuestions);
    }
  };

  const handleShortWhQuestionDelete = (index) => {
    let updatedQuestions = [...whQuestions];
    updatedQuestions.splice(index, 1);
    setWhQuestions(updatedQuestions);
    setTotalWhQuestions(updatedQuestions.length);

  };

  const combineWhQuestions = (shortQuestions, longQuestions , interpretiveQuestions) => {
    const combinedQuestions = [];

    if (shortQuestions) {
      combinedQuestions.push(...(shortQuestions?.questions || shortQuestions));
    }

    if (longQuestions) {
      combinedQuestions.push(...(longQuestions?.questions || longQuestions));
    }

    if (interpretiveQuestions){
      combinedQuestions.push(...(interpretiveQuestions?.questions || interpretiveQuestions))
    }
    return combinedQuestions;
  };  

      function removeDuplicateQuestions(input) {
    const seen = new Set();
  
    // Normalize input to always be an array
    const questionsArray = Array.isArray(input)
      ? input
      : input?.questions || [];
  
    return questionsArray.filter((q) => {
      const text = (q.Question ?? q.question ?? "").toLowerCase().replace(/\s+/g, " ").trim();
      if (seen.has(text)) return false;
      seen.add(text);
      return true;
    });
  }
  

   useEffect(() => {
    if (generatedQuestionsFromSubmitContent) {
      var shortQuestions =
        generatedQuestionsFromSubmitContent?.questions?.questionset?.short_questions?.questions ||
        generatedQuestionsFromSubmitContent?.questions?.questionset?.questionset?.short_questions?.questions ||
        generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.short_questions ||
        generatedQuestionsFromSubmitContent?.questionset?.short_questions ||
        generatedQuestionsFromSubmitContent?.short_questions?.questions ||
        [];

      var longQuestions =
        generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.descriptive_questions ||
        generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.questionset?.descriptive_questions ||
        generatedQuestionsFromSubmitContent?.questions?.questionset?.descriptive_questions?.questions ||
        generatedQuestionsFromSubmitContent?.questions?.questionset?.questionset?.descriptive_questions?.questions ||
        generatedQuestionsFromSubmitContent?.questionset?.descriptive_questions ||
        generatedQuestionsFromSubmitContent?.descriptive_questions?.questions ||
        [];

      var interpretiveQuestions =   
          generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.interpretive_questions ||
          generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.questionset?.interpretive_questions ||
          generatedQuestionsFromSubmitContent?.questions?.questionset?.interpretive_questions?.questions ||
          generatedQuestionsFromSubmitContent?.questions?.questionset?.questionset?.interpretive_questions?.questions ||
          generatedQuestionsFromSubmitContent?.questionset?.interpretive_questions ||
          generatedQuestionsFromSubmitContent?.questionset?.interpretive_questions ||
          generatedQuestionsFromSubmitContent?.interpretive_questions?.questions ||

        [];
      // 🔁 Remove duplicates
  shortQuestions = removeDuplicateQuestions(shortQuestions);
  longQuestions = removeDuplicateQuestions(longQuestions);
  interpretiveQuestions = removeDuplicateQuestions (interpretiveQuestions);


      const combinedQuestions = combineWhQuestions(shortQuestions, longQuestions, interpretiveQuestions);

      setWhQuestions(combinedQuestions);
      setTotalWhQuestions(combinedQuestions.length);
    }
  }, [generatedQuestionsFromSubmitContent]);


  localStorage.setItem("whQuestionsCount", totalWhQuestions);

  return {
    totalWhQuestions,
    setTotalWhQuestions,
    whQuestions,
    shortQuestionsNotWH,
    handleShortWhQuestionChange,
    handleShortWhAnswerChange,
    handleShortWhQuestionsEdit,
    handleShortWhAnswersEdit,
    handleShortWhQuestionDelete,
  };
};
